module.exports = __webpack_public_path__ + "static/img/persevere.ef42afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/persevere.png
// module id = kniy
// module chunks = 0